export default {
  id: '73949984c4',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div id=app><!-- Left panel with cover effect--><div class="panel panel-right panel-cover theme-dark"><div class=view><div class=page><div class=navbar><div class=navbar-inner><div class=title>ASSEMILSAT</div></div></div><div class=page-content><div class="list links-list"><ul class=theme-dark><li><a href=/configuracao/ class=panel-close>Configurações</a></li><li><a href=/notificacoes/0/ class=panel-close>Notificações</a></li><li><a href=/sobre/ class=panel-close>Sobre o APP</a></li><li><a href=/central/ class=panel-close>Central de Atendimento</a></li><li><a href=/logout/ class=panel-close>Sair</a></li></ul></div></div></div></div></div><!-- Your main view, should have "view-main" class --><div class="view view-main view-init safe-areas" data-url=/ ></div></div>';
      return r;
    }(this);
  },
  styleScoped: false
};